(function (browserWindow, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (browserWindow) {
    browserWindow.GHMRequiredContactCore = api;
  }
}(typeof window !== 'undefined' ? window : undefined, function () {
  var EMAIL_EMPTY = 'Please enter your email address.';
  var EMAIL_INVALID = 'Please enter a valid email address.';
  var PHONE_EMPTY = 'Please enter your phone number, including country code.';
  var PHONE_INVALID = 'Please enter a valid phone number, including country code.';

  function toTrimmedString(value) {
    return value == null ? '' : String(value).trim();
  }

  function normalizeEmail(value) {
    return toTrimmedString(value);
  }

  function normalizePhone(value) {
    return toTrimmedString(value).replace(/[ ()-]/g, '');
  }

  function emailError(email) {
    if (!email) {
      return EMAIL_EMPTY;
    }

    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? '' : EMAIL_INVALID;
  }

  function phoneError(phone) {
    var compactPhone;

    if (!phone) {
      return PHONE_EMPTY;
    }

    if (!/^\+?[\d ()-]+$/.test(phone)) {
      return PHONE_INVALID;
    }

    compactPhone = normalizePhone(phone).replace(/^\+/, '');
    return /^\d{7,15}$/.test(compactPhone) ? '' : PHONE_INVALID;
  }

  function validateContact(contact) {
    var input = contact || {};
    var email = normalizeEmail(input.email);
    var phone = normalizePhone(input.phone);
    var errors = {
      email: emailError(email),
      phone: phoneError(toTrimmedString(input.phone))
    };

    return {
      valid: !errors.email && !errors.phone,
      normalized: { email: email, phone: phone },
      errors: errors
    };
  }

  function isContactComplete(contact) {
    return validateContact(contact).valid;
  }

  return {
    normalizeEmail: normalizeEmail,
    normalizePhone: normalizePhone,
    validateContact: validateContact,
    isContactComplete: isContactComplete
  };
}));
